import React from 'react';

const PurchaseConfirmationModal = ({ onClose, orderDetails, customerInfo }) => {
  const { cartItems, total } = orderDetails;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-8 text-center relative overflow-y-auto max-h-[90vh]">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h3 className="text-3xl font-bold text-gray-900 mb-4">¡Gracias por tu compra!</h3>
        <p className="text-gray-700 text-lg mb-6">En breve nos pondremos en contacto contigo para coordinar la entrega.</p>

      <div className="text-left mb-6 p-4 bg-gray-50 rounded-lg overflow-x-auto">
  <h4 className="text-xl font-semibold text-gray-800 mb-4">Detalle de tu Pedido:</h4>
  <table className="w-full text-left text-gray-700">
    <thead>
      <tr className="border-b border-gray-300 text-sm font-semibold text-gray-600">
        <th className="py-2 pr-2">Cantidad</th>
        <th className="py-2 px-2">Artículo</th>
        <th className="py-2 px-2">Precio Unitario</th>
        <th className="py-2 pl-2 text-right">Subtotal</th>
      </tr>
    </thead>
    <tbody>
      {cartItems.map((item) => (
        <tr key={item.id} className="border-b border-gray-200">
          <td className="py-2 pr-2">{item.quantity}</td>
          <td className="py-2 px-2">{item.name}</td>
          <td className="py-2 px-2">₡{item.price.toLocaleString('es-CR', { minimumFractionDigits: 2 })}</td>
          <td className="py-2 pl-2 text-right">₡{(item.price * item.quantity).toLocaleString('es-CR', { minimumFractionDigits: 2 })}</td>
        </tr>
      ))}
      <tr>
        <td colSpan="3" className="text-right pt-4 pr-4 text-lg font-bold">Total:</td>
        <td className="pt-4 text-right text-lg font-bold text-gray-800">
          ₡{total.toLocaleString('es-CR', { minimumFractionDigits: 2 })}
        </td>
      </tr>
    </tbody>
  </table>
</div>

     

        <button
          onClick={onClose}
          className="bg-[#5A61E5] text-white px-8 py-3 rounded-xl hover:bg-[#4A51D5] transition-colors duration-300 shadow-lg text-lg font-semibold"
        >
          Volver a la Tienda
        </button>
      </div>
    </div>
  );
};

export default PurchaseConfirmationModal;